import * as R from 'ramda'
import { CustomAction } from '@weblite-wapps/protocol'
import { getState } from '../setup/redux'
import {
  ADD_TO_WAPP_POOL,
  REMOVE_FROM_WAPP_POOL,
  SET_WAPPRUNNER_STAGE,
  SET_WAPP_CUSTOM_ACTIONS,
  SET_WAPP_BOOKMARK_DATA,
  SET_WAPP_OUTPUT,
} from './wapprunnerPool.action'
import { BookmarkData, WappSession, WappStage } from '../common'

type WappPool = Record<string, WappSession>
// initial state
const wappPool: WappPool = {}

// views
export const wappPoolView = (): WappPool => R.prop('pool', getState())
export const wappPoolArrayView = (): WappSession[] => R.values(wappPoolView())
export const wappView = (wappSessionId: string): WappSession =>
  R.path(['pool', wappSessionId], getState())

// reducers
const reducers = {
  [ADD_TO_WAPP_POOL]: (state: WappPool, wapp: WappSession) =>
    R.assoc(wapp.wappSessionId, wapp, state),

  [REMOVE_FROM_WAPP_POOL]: (state: WappPool, wappSessionId: string) =>
    R.dissoc(wappSessionId, state),

  [SET_WAPPRUNNER_STAGE]: (
    state: WappPool,
    { wappSessionId, stage }: { wappSessionId: string; stage: WappStage },
  ) => R.assocPath([wappSessionId, 'stage'], stage, state),

  [SET_WAPP_CUSTOM_ACTIONS]: (
    state: WappPool,
    {
      wappSessionId,
      customActions,
    }: { wappSessionId: string; customActions?: CustomAction[] },
  ) =>
    R.assocPath(
      [wappSessionId, 'customActions'],
      R.concat(customActions, state?.[wappSessionId]?.customActions || []),
      state,
    ),

  [SET_WAPP_BOOKMARK_DATA]: (
    state: WappPool,
    {
      wappSessionId,
      bookmarkData,
    }: { wappSessionId: string; bookmarkData?: BookmarkData },
  ) => R.assocPath([wappSessionId, 'bookmarkData'], bookmarkData, state),

  [SET_WAPP_OUTPUT]: (
    state: WappPool,
    { wappSessionId, output }: { wappSessionId: string; output?: unknown },
  ) => R.assocPath([wappSessionId, 'output'], output, state),
}

type Reducer = (state: WappPool, payload: unknown) => WappPool

export default (
  state = wappPool,
  { type, payload }: { type: string; payload: unknown },
) =>
  (reducers[type as keyof typeof reducers] as Reducer)?.(state, payload) ||
  state
